export default {"src":"/_next/static/image/public/images/flags/flag_222.6e08e3623d404cf76c17e06c3e1374c6.svg","height":16,"width":24};